// Configuração de runtime da SPA (Parte 14.8): `GET /config.json` servido pelo host (Giyus.Web) a partir de app settings —
// o mesmo bundle roda em dev/stage/prod. Vive neste pacote porque é o único lugar autorizado a chamar `fetch`
// (regra ESLint `giyus/no-raw-fetch`). Sem o arquivo (vite dev/preview) a SPA fica com o `.env` (VITE_*).

export const RUNTIME_CONFIG_PATH = '/config.json';

export interface RuntimeConfig {
  readonly apiBaseUrl: string;
  readonly oidcAuthority: string;
  readonly oidcClientId: string;
  readonly environment: string;
  readonly version: string;
}

const KEYS = ['apiBaseUrl', 'oidcAuthority', 'oidcClientId', 'environment', 'version'] as const;

/** Mantém só as chaves conhecidas com valor de texto não vazio; qualquer outra forma vira `{}`. */
export function parseRuntimeConfig(payload: unknown): Partial<RuntimeConfig> {
  if (typeof payload !== 'object' || payload === null || Array.isArray(payload)) {
    return {};
  }
  const record = payload as Record<string, unknown>;
  const result: { -readonly [K in keyof RuntimeConfig]?: string } = {};
  for (const key of KEYS) {
    const value = record[key];
    if (typeof value === 'string' && value.trim() !== '') {
      result[key] = value.trim();
    }
  }
  return result;
}

/**
 * Lê `/config.json` na mesma origem, sem cache. Devolve `null` quando o host não o serve (404, corpo não-JSON, rede) —
 * nunca lança: a ausência é o caso normal em desenvolvimento.
 */
export async function loadRuntimeConfig(
  fetchImpl: typeof globalThis.fetch = globalThis.fetch,
  path: string = RUNTIME_CONFIG_PATH,
): Promise<Partial<RuntimeConfig> | null> {
  try {
    const response = await fetchImpl(path, {
      cache: 'no-store',
      headers: { accept: 'application/json' },
    });
    if (!response.ok) {
      return null;
    }
    const contentType = response.headers.get('content-type') ?? '';
    if (!contentType.toLowerCase().includes('application/json')) {
      return null;
    }
    return parseRuntimeConfig(await response.json());
  } catch {
    return null;
  }
}
